import { render, staticRenderFns } from "./RecruitNew.vue?vue&type=template&id=894190ec&scoped=true"
import script from "./RecruitNew.vue?vue&type=script&lang=js"
export * from "./RecruitNew.vue?vue&type=script&lang=js"
import style0 from "./RecruitNew.vue?vue&type=style&index=0&id=894190ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894190ec",
  null
  
)

export default component.exports